import Image from "next/image";

import {
  ImageWrapper1,
  ImageWrapper2,
  ImageWrapper3,
} from "./BorderedImage.styled";

interface BorderedImage {
  src: string;
  alt: string;
  priority?: boolean;
}

export const BorderedImage = ({ src, alt, priority }: BorderedImage) => {
  return (
    <ImageWrapper1>
      <ImageWrapper2>
        <ImageWrapper3>
          <Image
            src={src}
            alt={alt}
            fill
            className="object-cover"
            priority={priority}
          />
        </ImageWrapper3>
      </ImageWrapper2>
    </ImageWrapper1>
  );
};
